import React from 'react';
import { translate } from 'react-polyglot';
import { Dropdown, DropdownTrigger, DropdownMenu, DropdownMenuItem } from 'decap-cms-ui-next';
import { ControlButton } from './ControlButton';
import { jsx as ___EmotionJSX } from "@emotion/react";
function GroupControl({
  viewGroups,
  t,
  onGroupClick,
  group
}) {
  const hasActiveGroup = group === null || group === void 0 ? void 0 : group.valueSeq().toJS().some(f => f.active === true);
  return ___EmotionJSX(Dropdown, null, ___EmotionJSX(DropdownTrigger, null, ___EmotionJSX(ControlButton, {
    active: hasActiveGroup
  }, t('collection.collectionTop.groupBy'))), ___EmotionJSX(DropdownMenu, {
    anchorOrigin: {
      y: 'bottom',
      x: 'right'
    }
  }, viewGroups.map(viewGroup => {
    return ___EmotionJSX(DropdownMenuItem, {
      key: viewGroup.id,
      onClick: () => onGroupClick(viewGroup),
      selected: group.getIn([viewGroup.id, 'active'], false)
    }, viewGroup.label);
  })));
}
export default translate()(GroupControl);